import { ComedianSigninHeader, VenueSigninHeader } from "../signin";

import { AttendanceData } from "@punchup/data/legacy";
import { Comedian } from "@punchup/data/legacy";
import { Livestream } from "@punchup/data/legacy/livestreaming";
import LivestreamCheckoutScheduledTime from "./LivestreamCheckoutScheduledTime";
import { SpecialPreviewPlayer } from "../special";
import SpecialPreviewPrompt from "../special/SpecialPreviewPrompt";
import { SpecialRow } from "@punchup/data/legacy";
import { VenuePagesRow } from "@punchup/data/legacy";
import { getCDNImageURL } from "@punchup/utils/getCDNImageURL";

type CheckoutHeaderProps =
  | {
      comedian: Comedian;
      showPreview?: false;
      special?: SpecialRow;
      livestream?: Livestream | null;
      showWelcomeBanner: boolean;
      amount?: number;
      attendanceData?: AttendanceData;
      isPaidCheckout?: boolean;
    }
  | {
      comedian: Comedian;
      showPreview: true; // if show preview is true, then special is required
      special: SpecialRow;
      livestream?: Livestream | null;
      showWelcomeBanner: boolean;
      amount?: number;
      attendanceData?: AttendanceData;
      isPaidCheckout?: boolean;
    };

export default function CheckoutHeader({
  comedian,
  special,
  livestream,
  showPreview = true,
  showWelcomeBanner,
  attendanceData,
  isPaidCheckout = false,
}: CheckoutHeaderProps) {
  const showSpecialPreview =
    showPreview &&
    special &&
    special.preview_video_id !== null &&
    !showWelcomeBanner;

  const aboutImgUrl = comedian.about_img
    ? getCDNImageURL(comedian.about_img)
    : null;

  const specialImg =
    special && special.poster_img_with_titles
      ? getCDNImageURL(special.poster_img_with_titles)
      : null;

  if (isPaidCheckout) {
    return (
      <div className="flex flex-col w-full">
        {!showSpecialPreview ? (
          <ComedianSigninHeader
            comedian={comedian}
            aboutImg={aboutImgUrl}
            specialImg={specialImg}
            special={special}
            attendanceData={attendanceData}
          />
        ) : (
          <>
            <div className="w-full relative aspect-video rounded-lg mt-10 md:mt-20 overflow-hidden">
              <SpecialPreviewPlayer special={special} comedian={comedian} />
            </div>
            <div className="mt-4 mb-6">
              <h2 className="text-lg font-medium text-gray-900">
                {special.title} | {comedian.display_name}
              </h2>
            </div>
            {livestream && livestream.start_time && (
              <div className="-mt-2 mb-6">
                <LivestreamCheckoutScheduledTime livestream={livestream} />
              </div>
            )}
          </>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-row justify-center w-full md:mt-4">
      <div className="w-full max-w-md">
        {!showSpecialPreview ? (
          <ComedianSigninHeader
            comedian={comedian}
            aboutImg={aboutImgUrl}
            specialImg={specialImg}
            special={special}
            attendanceData={attendanceData}
          />
        ) : (
          <>
            <SpecialPreviewPlayer special={special} comedian={comedian} />
            <SpecialPreviewPrompt special={special} comedian={comedian} />
          </>
        )}
      </div>
    </div>
  );
}

export function VenueCheckoutHeader({ venue }: { venue: VenuePagesRow }) {
  return (
    <div className="flex flex-row justify-center w-full md:mt-6">
      <div className="w-full max-w-md">
        <VenueSigninHeader venue={venue} />
      </div>
    </div>
  );
}
